/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import http from './driver';
import { GameGroup } from './types/game';

export const getGames = (filter?: string) => http.get<GameGroup[]>('games', { filter });
export const getDaily = (game: string) => http.get(`${game}/daily`);
